/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { Effect, Nullable, OperationSuccess } from "../../utils/Interfaces";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { postHandler, stdErrHandlerFactory } from "../../utils/Requests";

export function modifyField<T>(
    updatePath: string,
    updateKey: keyof T,
    updateValue: Nullable<string | number | boolean>,
    dispatch: Dispatch<AnyAction>,
    onModified?: Effect
) {
    // There are cheap workarounds for this error, but they are not as type-specific. This approach is more
    // readable than using the ambiguous type `{[t: string]: Nullable<string | number| boolean>}`.
    // @ts-ignore
    let data: { [key in keyof T]: Nullable<string | number | boolean> } = {
        [updateKey]: updateValue,
    };

    postHandler<any, OperationSuccess>(
        updatePath,
        data,
        dispatch,
        () => (onModified ? onModified() : null),
        stdErrHandlerFactory(dispatch)
    );
}
